module.exports = __webpack_public_path__ + "static/20200811_111513-68e04a5e058e3288ee758c418477e6a9.jpg";